<script>
import Form from '../form/Component'
export default Form
</script>
